import { render, staticRenderFns } from "./albertactionreport.vue?vue&type=template&id=1dc1e4c7&"
import script from "./albertactionreport.vue?vue&type=script&lang=js&"
export * from "./albertactionreport.vue?vue&type=script&lang=js&"
import style0 from "./albertactionreport.vue?vue&type=style&index=0&id=1dc1e4c7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports